import { Key, useMemo } from "react";
import { useNavigate } from "react-router";
import { Card, CardBody, Listbox, ListboxItem } from "@heroui/react";
import { ToolboxIcon } from "@phosphor-icons/react";

import { ICON_SIZE } from "@/config/constants";
import { usePageLayout } from "@/app/hooks/usePageLayout";

export function NoteSettingsRoute() {
  const navigate = useNavigate();

  const handleAction = (key: Key) => {
    if (key === "toolbar") {
      navigate("toolbar");
    }
  };

  const pageLayoutConfig = useMemo(() => ({ navbar: { title: "Editor Settings" } }), []);
  usePageLayout(pageLayoutConfig);

  return (
    <>
      <Card className="mx-auto max-w-lg">
        <CardBody>
          <Listbox aria-label="Note settings" onAction={handleAction}>
            <ListboxItem
              key="toolbar"
              startContent={<ToolboxIcon size={ICON_SIZE.lg} />}
              description="Customize the note editor toolbar"
            >
              Toolbar
            </ListboxItem>
          </Listbox>
        </CardBody>
      </Card>
    </>
  );
}
